import React from "react";
import { Container, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/styles/CommonHero.css";

const GlobalImpactHero = () => {
  const handleGetInTouch = () => {
    // Redirect to LinkedIn profile
    window.open("https://www.linkedin.com/in/m-talha-6b1222251", "_blank");
  };

  return (
    <div className="hero-common-section">
      <Container className="text-white d-flex flex-column align-items-start justify-content-center h-100">
        <p className="small-text">OUR GLOBAL IMPACT</p>
        <h1 className="common-hero-text">Making a difference <br/>  worldwide</h1>
        <Button 
          variant="light" 
          className="mt-3"
          onClick={handleGetInTouch}
        >
          GET IN TOUCH
        </Button>
      </Container>
    </div>
  );
};

export default GlobalImpactHero;
